import React, {createContext, useContext, useState} from 'react';
import {toast} from "react-toastify";
import AgentService from "../services/Agent.service";
import {useEffect} from "react";
import {clearLocalStorage, empty} from "../common/util/functions";

export const AuthContext = createContext()

function AuthContextProvider(props) {
  const agentService = new AgentService()
  const [activeUser, setActiveUser] = useState(null)
  const [loadingProfile , setLoadingProfile] = useState(true)

  useEffect(()=>{
    fetchUserData()
  }, [])

  const fetchUserData = async () => {
    const token = localStorage.getItem('X_AG_CUR_TOKEN')
    if (!empty(token)) {
      setLoadingProfile(true)
      await agentService.myProfile().then(res => {
        setLoadingProfile(false)
        if (res.success) {
          setActiveUser(res.data)
        } else {
          toast.error(res.message)
        }
      })
    }
    else {
      setLoadingProfile(false)
    }
  }

  const logout = async () => {
    clearLocalStorage()
    setActiveUser(null)
  }

  const value = {activeUser, loadingProfile, fetchUserData, logout}
  return (
    <AuthContext.Provider value={value}>
      {props.children}
    </AuthContext.Provider>
  )

}

function useAuthContext() {
    const context = useContext(AuthContext)
    /*if (context === undefined) {
        throw new Error('usePrefix must be used within a AuthProvider')
    }*/
    return context
}


export {useAuthContext}

export default AuthContextProvider;
